<template>
  <b-navbar
    toggleable="lg"
    :variant="getLayoutNavbarBg()"
    class="layout-navbar login-navbar align-items-lg-center container-p-x"
    style="height: 85px;"
  >
    <div class="logo-wrapper">
      <img src="logo_white.png" alt="" class="img-fluid logo">
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: "app-layout-navbar",

  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    getLayoutNavbarBg() {
      return 'navbar-default';
    }
  }
};
</script>
